import { Button, UploadFileDialog } from "@/shared/components";
import { normalizeError } from "@/shared/utils";
import { useUploadRoutes } from "@/features/tvv/hooks";

export function UploadRoutes() {
    const uploadRoutes = useUploadRoutes();

    async function handleFileUpload(file: File) {
        try {
            await uploadRoutes.mutateAsync(file);
        } catch (error) {
            throw normalizeError(error);
        }
    }

    return (
        <UploadFileDialog
            title="Upload TVV routes"
            label="TVV routes"
            allowedExtensions={["csv"]}
            handleFileUpload={handleFileUpload}
            isPending={uploadRoutes.isPending}
        >
            <Button variant="secondary">Upload TVV routes</Button>
        </UploadFileDialog>
    );
}
